import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

const scheme = process.env.MIX_PUSHER_APP_SCHEME || window.location.protocol.replace(':', '')
const socketPort = Number(process.env.MIX_PUSHER_APP_PORT || (scheme === 'https' ? 443 : 6001))

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    wsHost: process.env.MIX_PUSHER_HOST || window.location.hostname,
    wsPort: socketPort,
    wssPort: socketPort,
    forceTLS: scheme === 'https',
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
});
